var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { feathersAuthentication } from 'src/feathers';
import ButtonLoginFacebook from './ButtonLoginFacebook';
import ButtonLoginGoogle from './ButtonLoginGoogle';
import ButtonLoginDev from './ButtonLoginDev';
var Authentication = (function (_super) {
    __extends(Authentication, _super);
    function Authentication(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            isBlockingLogin: false,
        };
        _this.handleBlockOtherLoginMethods = _this.handleBlockOtherLoginMethods.bind(_this);
        return _this;
    }
    Authentication.prototype.componentWillMount = function () {
        if (this.props.isAuthenticated) {
            this.props.navigateToNext();
        }
    };
    Authentication.prototype.handleBlockOtherLoginMethods = function (isFetchingLogin) {
        this.setState({ isBlockingLogin: isFetchingLogin });
    };
    Authentication.prototype.render = function () {
        return (React.createElement(React.Fragment, null,
            process.env.NODE_ENV === 'development' &&
                React.createElement(ButtonLoginDev, { navigateToNext: this.props.navigateToNext }),
            React.createElement(ButtonLoginFacebook, { isDisabled: this.state.isBlockingLogin, navigateToNext: this.props.navigateToNext, handleBlockOtherLoginMethods: this.handleBlockOtherLoginMethods }),
            React.createElement(ButtonLoginGoogle, { isDisabled: this.state.isBlockingLogin, navigateToNext: this.props.navigateToNext, handleBlockOtherLoginMethods: this.handleBlockOtherLoginMethods })));
    };
    return Authentication;
}(React.Component));
var mapStateToProps = function (state) { return ({
    isAuthenticated: state.auth.isSignedIn,
}); };
var mapDispatchToProps = function (dispatch) { return ({
    actions: bindActionCreators({
        handleLoginRequest: feathersAuthentication.authenticate,
        handleLogoutRequest: feathersAuthentication.logout,
    }, dispatch),
}); };
export default connect(mapStateToProps, mapDispatchToProps)(Authentication);



//////////////////
// WEBPACK FOOTER
// ./src/pages/components/Authentication/index.tsx
// module id = 691
// module chunks = 0